/** Figma group-by dropdown (node 75644:10729) */
export const PLAN_GROUP_BY_MENU_MIN_WIDTH = '220px';
export const PLAN_GROUP_BY_MENU_RADIUS = '12px';
